import { makeAssessmentService } from "services/assessmentService";

const volunteerService = makeAssessmentService("volunteers");

export default volunteerService;
